export const SET_LOCALIZATION_LANGS = 'SET_LOCALIZATION_LANGS';
export const SET_LOCALIZATION_LANGS_SUCCESS = 'SET_LOCALIZATION_LANGS_SUCCESS';